import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function LoadingIcon() {
  return <CircularProgress size={32} thickness={3} />;
}
